import styles from './currentTab3.module.scss';
import Image from 'next/image';

const CurrentTab3 = ({
  handleCloseThankYou,
}: {
  handleCloseThankYou: () => void;
}) => {
  return (
    <div className={styles.thankYouContainer}>
      <Image
        src="/img/heroBlock/success-img.webp"
        alt="Thank you"
        width={136}
        height={108}
      />
      <div className={styles.thankYouText}>
        <h2 className={styles.thankYouTitle}>Thank you for your order.</h2>
        <p className={styles.thankYouDescription}>
          Our support team is already aware and will contact you soon. This
          usually takes up to 15 minutes.
        </p>
      </div>

      <div className={styles.thankYouButton} onClick={handleCloseThankYou}>
        <Image src="/img/modal/close.svg" alt="close" width={24} height={24} />
      </div>
    </div>
  );
};

export default CurrentTab3;
